import { useState, useEffect, useCallback, KeyboardEventHandler, useMemo } from "react";
import { useStore } from "@ui/hooks/useStore";
import useKeyDown from "@ui/hooks/useKeyDown";
import { ICloseEvent } from "@core/interfaces/ICloseEvent";
import { SelectProps, SelectChangeEvent } from "@mui/material";
import { IState } from "./IState";

const useAddDeviceToSubuser = (onClose: ICloseEvent["onClose"]) => {
    const { devices, subusers, groups, lang } = useStore();
    const key = useKeyDown();

    const devicesList = useMemo(() => {
        const [subuserItem] = subusers.subusersDevices.filter(({ subuser }) => subuser === subusers.selectedSubuser);
        let deviceList: string[] = [];
        if (subuserItem && subuserItem.devices) deviceList = subuserItem.devices;
        return devices.deviceList
            .filter(({ imei }) => !deviceList.includes(imei))
            .map(({ imei: value, name: label }) => ({ value, label }));
    }, [subusers.subusersDevices, subusers.selectedSubuser, devices.deviceList]);

    const values = {
        devicesList,
    };

    const initState: IState[] = [];

    const [state, setState] = useState(initState);

    const handleStateChange = useCallback((newState: IState[]) => {
        setState(newState);
    }, []);

    // const initState: IState = {
    //     selectedImei: null,
    //     rights: {
    //         send_commands: true,
    //         change_settings: true,
    //     },
    // };
    // const [state, setState] = useState(initState);

    // const handleInputClick = useCallback(() => {
    //     subusers.resetServerError();
    // }, []);
    // const handleImeiChange: SelectProps<string>['onChange'] = useCallback(
    //     (e: SelectChangeEvent<string>) => {
    //         handleInputClick();
    //         const selectedImei = e.target.value;
    //         setState((prev) => ({
    //             ...prev,
    //             selectedImei,
    //         }));
    //     },
    //     [],
    // );
    // const handleSendCommandsChange = useCallback(() => {
    //     setState((prev) => ({
    //         ...prev,
    //         rights: {
    //             ...prev.rights,
    //             send_commands: !prev.rights.send_commands,
    //         },
    //     }));
    //     handleInputClick();
    // }, []);
    // const handleSettingsChange = useCallback(() => {
    //     setState((prev) => ({
    //         ...prev,
    //         rights: {
    //             ...prev.rights,
    //             change_settings: !prev.rights.change_settings,
    //         },
    //     }));
    //     handleInputClick();
    // }, []);
    const handleAddClick = useCallback(() => {
        subusers.resetServerError();
        if (state.length > 0) {
            Promise.allSettled(state.map(({ selectedImei, rights }) => subusers.addDevice(selectedImei, rights)));
        }
    }, [state]);
    const handleKey = (key: string) => {
        switch (key) {
            case "Escape":
                onClose();
                break;
            case "Enter":
                handleAddClick();
                break;
        }
    };
    const handleBtnKeyDown: KeyboardEventHandler<HTMLButtonElement> = useCallback((e) => {
        const { key } = e;
        if (key === "Enter") {
            e.stopPropagation();
            e.preventDefault();
            const target = e.target as HTMLButtonElement;
            target.click();
        }
    }, []);
    const handleSelectKeyDown: KeyboardEventHandler<HTMLElement> = useCallback((e) => {
        const { key } = e;
        if (key === "Enter") {
            e.stopPropagation();
            e.preventDefault();
        }
    }, []);
    const handlers = {
        handleAddClick,
        handleStateChange,
        handleBtnKeyDown,
        handleSelectKeyDown,
    };

    useEffect(() => {
        subusers.resetServerError();
    }, []);
    useEffect(() => {
        if (subusers.operationSuccess) {
            onClose();
            subusers.resetOperationSuccess();
        }
    }, [subusers.operationSuccess]);
    useEffect(() => {
        handleKey(key);
    }, [key]);
    useEffect(() => {
        if (!subusers.selectedSubuser && !subusers.loading) onClose();
    }, [subusers.selectedSubuser, subusers.loading]);
    // useEffect(() => {
    //     if (!devices.loading && !devices.deviceList.some(({ imei }) => state.selectedImei === imei)) {
    //         setState((prev) => ({ ...prev, selectedImei: null }));
    //     }
    // }, [devices.deviceList, devices.loading]);

    return {
        subusers,
        groups,
        lang,
        devices,
        state,
        handlers,
        values,
    };
};

export default useAddDeviceToSubuser;
